import React from "react";
import { isEmpty, noop }  from 'lodash';
import moment from "moment";
import {  PlayCircleOutlined } from '@ant-design/icons';
import message from 'components/CustomMessage';
import ToolsIntegrationsAPI from "restAPI/ToolsIntegrationAPI";


const triggerStartScanTool = (record, callBack=noop) => {
  const { data, name } = record;
  if (!isEmpty(data) && name === "start_scanTool") {
    const { promise } = ToolsIntegrationsAPI.startToolScan(data.tool_name, data.id)
    promise.then(() => {
      message.success('Tool scan started successfully.');
    }).finally(() => callBack());
  }
};

const getFortifyScanActionOptions = (record) => {
  const lastToolScanDate = moment(record.lastToolScanDate);
  const currentDate = moment();
  const hasDifference = currentDate.diff(lastToolScanDate, 'minutes') <= 1;
  const tooltip = hasDifference ? 'Tool scanning in progress.' : 'Start tool scan.';
  const fields = [
      {
          type: "start_scanTool",
          text: "Start tool scan",
          icon: <PlayCircleOutlined /> ,
          tooltip: tooltip,
          disabled: hasDifference
        }
  ]
  return fields;
}

  export {
    triggerStartScanTool,
    getFortifyScanActionOptions
  }

